<template>
<div class=" ">
    <lcontainer class="mb-4">
        <div class="heading flex flex-row items-center justify-between py-2 px-8">
            <div>
                <div class="page text-white mb-4">Program Management</div>
            </div>
            <div>
                <img :src="require('../../../assets/tenant_image.png')" alt="" />
            </div>
        </div>
    </lcontainer>
    <lcontainer>
        <div class="bg-white px-8 py-4">
            <lCrumbs :breadcrumb="breadcrumbItems" />
            <div class="flex flex-row flex-wrap">
                <div class="flex flex-col flex-wrap flex-grow items-start mb-12 mr-12">
                    <div class="flex flex-row flex-wrap items-center form-row mb-8">
                        <div class="modal-field font-semibold">Title:</div>
                        <div class="flex-grow ml-auto">
                            <linput type="text" name="fname" v-model="form.title" :errorMessage="errors.title" :error="errors.title" placeholder="Title of Program" />
                        </div>
                    </div>
                    <div class="flex flex-row flex-wrap items-center form-row mb-8">
                        <div class="modal-field font-semibold ">Description:</div>
                        <div class="flex-grow ml-auto">
                            <ltextarea v-model="form.description" :errorMessage="errors.description" :error="errors.description" placeholder="Program Description" />
                        </div>
                    </div>
                    <div class="flex flex-row flex-wrap items-center form-row mb-8">
                        <div class="modal-field font-semibold ">
                            Overview Image URL:
                        </div>
                        <div class="flex-grow ml-auto">
                            <vue-dropzone @vdropzone-drag-drop="
                    form.image = $event;
                    uploads = [''];
                  " @vdropzone-file-added="
                    form.image = $event;
                    uploads = [''];
                  " ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                        </div>
                        <div class="mt-4 w-1/2 px-2">
                            <img :src="form.image" alt="" />
                        </div>
                    </div>
                    <div class="flex flex-row items-center form-row mb-8">
                        <div class="modal-field font-semibold">
                            Overview Video:
                        </div>
                        <div class="flex-grow ml-auto">
                            <lselect selected :error="errors.video_overview" v-model="form.video_overview" :editValue="form.video_overview" :errorMessage="errors.video_overview" :items="getResources" placeholder="Select Overview Video" />
                        </div>
                    </div>
                </div>
                <div v-if="form.type" class="flex flex-col flex-wrap flex-grow items-start mb-12">
                    <div v-show="false" class="flex flex-row flex-wrap items-center form-row mb-8">
                        <div class="modal-field font-semibold">Payment Type:</div>
                        <div class="flex-grow ml-auto">
                            <lselect :error="errors.type" v-model="form.type" :errorMessage="errors.type" :editValue="form.type" :items="types" placeholder="Select Payment Type" />
                        </div>
                    </div>
                    <div class="flex flex-row flex-wrap items-center form-row mb-8">
                        <div class="modal-field font-semibold">Subscription Type:</div>
                        <div class="flex-grow ml-auto">
                            <lselect :error="errors.subscription_type" v-model="form.subscription_type" :errorMessage="errors.subscription_type" :editValue="form.subscription_type" :items="subscription_types" placeholder="Select Subscription Type" />
                        </div>
                    </div>

                    <div v-if="form.subscription_type == 'discounted'" class="flex flex-row flex-wrap items-center form-row mb-8">
                        <div class="modal-field font-semibold ">
                            Subscription Count:
                        </div>
                        <div class="flex-grow ml-auto">
                            <linput v-model="form.discount_count" :error="errors.discount_count" :errorMessage="errors.discount_count" type="text" placeholder="Enter Discount Count" />
                        </div>
                    </div>
                    <div v-if="
                form.subscription_type == 'discounted' && form.discount_cost
              " class="flex flex-row flex-wrap items-center form-row mb-8">
                        <div class="modal-field  font-semibold ">
                            Discount Cost:
                        </div>
                        <div>
                            <linput v-model="form.discount_cost" :error="errors.discount_cost" :errorMessage="errors.discount_cost" type="text" placeholder="Enter Discount Cost" />
                        </div>
                    </div>

                    <div class="flex flex-row flex-wrap items-center form-row mb-8">
                        <div class="modal-field font-semibold">Visibility Type:</div>
                        <div class="flex-grow ml-auto">
                            <lselect :error="errors.status_subscription" v-model="form.status_subscription" :errorMessage="errors.status_subscription" :editValue="form.status_subscription" :items="status" placeholder="Select Subscription Status" />
                        </div>
                    </div>

                    <div class="flex flex-row flex-wrap items-center form-row mb-8">
                        <div class="modal-field font-semibold ">
                            Subscription Cost:
                        </div>
                        <div class="flex-grow ml-auto">
                            <linput v-model="form.subscription_cost" :error="errors.subscription_cost" :errorMessage="errors.subscription_cost" type="text" placeholder="Enter Subscription Cost" />
                        </div>
                    </div>

                    <div class="flex flex-row flex-wrap items-center form-row mb-8">

                        <div class="w-full my-3 md:w-1/2 flex row ">
                            <div class="mx-2 mt-2 modal-field font-semibold">
                                Include Subscription Limit:
                            </div>

                            <div class="my-2">
                                <switches color="green" v-model="form.subscription_limit">
                                </switches>
                                <span class="ml-4 mb-2 pb-2 font-bold">{{
                    form.subscription_limit ? "Yes" : "No"
                  }}</span>
                            </div>

                        </div>
                        <div class="my-2" v-if="form.subscription_limit">
                            How Many Days is this course valid:
                            <linput type="text" v-model="form.subscription_limit_count" :errorMessage="errors.subscription_limit_count" :error="errors.subscription_limit_count" placeholder="e.g 20 ( in days) " />
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col flex-wrap justify-center items-center">
                <div class="mb-8">
                    <lms-button :disabled="button.isLoading" @click="handleFormSubmit">{{ button.text }}</lms-button>
                </div>
            </div>
        </div>
    </lcontainer>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations
} from "vuex";
import FormActions from "@/mixins/FormActions";
import Switches from "vue-switches";
export default {
    mixins: [FormActions],
    data() {
        return {
            select: "",
            button: {
                isLoading: false,
                text: "Update Program",
            },
            breadcrumbItems: [{
                    disabled: true,
                    to: "/tenant/programs",
                    text: "All Programs",
                },
                {
                    disabled: true,
                    to: "#",
                    text: "Edit Program",
                },
            ],
            roles: this.$store.state.admin.adminRoles,
            types: [{
                    text: "Free",
                    value: "free",
                },
                {
                    text: "Paid",
                    value: "paid",
                },
            ],
            status: [{
                    text: "External",
                    value: "external",
                },
                {
                    text: "Internal",
                    value: "internal",
                },
            ],
            uploads: [],
            subscription_types: [{
                    text: "Free",
                    value: "free",
                },
                {
                    text: "Individual",
                    value: "individual",
                },
                {
                    text: "Bulk",
                    value: "bulk",
                },
                {
                    text: "Discounted",
                    value: "discounted",
                },
            ],
            errors: [],
            form: {},
        };
    },
    props: {},
    computed: {
        ...mapGetters(["getTenantPrograms", "getResources"]),
    },
    methods: {
        ...mapMutations(["updateLoader"]),
        validateSelection(selection) {
            //console.log({ selection });
        },

        async loadResource(e) {
            let res = await this.loadUserAssets();
            this.showAssets = true;
        },
        ...mapActions([
            "editTenantProgram",
            "updateTenantProgram",
            "loadUserAssets",
        ]),
        async handleFormSubmit() {
            this.errors = [];
            this.button.isLoading = true;
            this.button.text = "Loading....";

            this.updateLoader(true);
            if (this.uploads.length > 0) {
                this.form.image = await this.uploadFile(this.form.image);
            }
            this.form.type = this.form.subscription_type === 'free' ? 'free' : 'paid'
            let res = await this.updateTenantProgram(this.form);
            this.updateLoader(true);
            if (res == true || res.status == 200 || res.status == 201) {
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Program updated successfully",
                });

                this.form = {};
                this.$router.push({
                    name: "tenant-programs",
                });
            } else {
                this.errors = res.data.errors[0].source;
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title : "An error occured",
                });
            }
        },
        close() {
            this.$emit("closeProgramModal", false);
        },
    },
    async mounted() {
        this.updateLoader(true);
        this.loadResource();
        let res = await this.editTenantProgram({
            id: this.$route.params.id,
        });
        this.form = res;
        if (res.subscription) {
            this.form.subscription_type = res.subscription.subscription_type;
            this.form.discount_count = res.subscription.discount_count;
            this.form.discount_cost = res.subscription.discount_cost;
            this.form.status_subscription = res.subscription.status_subscription;
            this.form.subscription_cost = res.subscription.subscription_cost;
        }
        this.updateLoader(false);
    },
    components: {
        linput: () => import("@/components/general/input"),
        ltextarea: () => import("@/components/general/textarea"),
        LmsButton: () => import("@/components/general/button"),
        lselect: () => import("@/components/forms/select"),
        LSearchSelect: () => import("@/components/forms/search.vue"),
        lcontainer: () => import("@/components/general/container"),
        lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
        Switches
    },
};
</script>

<style lang="scss" scoped>
.form-row {
    width: 100%;
}

.modal {
    z-index: 10;

    .overlay {
        background: #b1b3b9;
        opacity: 0.89;
        z-index: 0;
    }

    .modal-content {
        width: 100%;
        width: 1001px !important;

        .modal-title {
            font-size: 24px;
            color: color(lms-tenant);
        }

        .modal-field {
            color: color(lms-tenant);
            max-width: calc(135px + 16px);
            width: 100%;
        }

        .close {
            background-color: #c2454b;
            height: 30px;
            width: 30px;
            border-radius: 50%;
            font-size: 12px;
            top: 0px;
            z-index: 2;
            right: 0px;
        }

        z-index: 1;
    }
}
</style>
